import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import FormattedCurrency from 'components/ui/FormattedCurrency';
import { SummaryBlock, Paragraph } from './Ticket.styles';
import { Link } from 'react-router-dom';

const Ticket = ({
  ticket: { name, code, quantity, price, total, currency, discounts = [], originalPrice, confirmedTimestamp, loyaltyPoints },
  costPrice,
  vouchers = [],
  isLoyalty
}) => {
  const hasDiscount = discounts?.length > 0;

  const getTicketPrice = () => (isLoyalty ? `${loyaltyPoints} pts` : <FormattedCurrency amount={Math.abs(price)} currency={currency} />);

  const getTicketTotalPrice = () =>
    isLoyalty ? `${loyaltyPoints * quantity} pts` : <FormattedCurrency amount={Math.abs(total)} currency={currency} />;

  return (
    <SummaryBlock data-cy="payment-ticket">
      <Paragraph>
        <strong>{name}</strong>
      </Paragraph>
      <Paragraph>
        <FormattedMessage id="paymentsTab.fareCode" />: {code}
      </Paragraph>
      <Paragraph>
        <FormattedMessage id="paymentsTab.quantity" />: {quantity} <FormattedMessage id="paymentsTab.pax" />
      </Paragraph>
      {hasDiscount ? (
        <>
          <Paragraph>
            <FormattedMessage id="paymentsTab.costBeforeDiscount" />: {}
            <FormattedCurrency amount={Math.abs(originalPrice)} currency={currency} />
          </Paragraph>
          <Paragraph>
            <FormattedMessage id="paymentsTab.costAfterDiscount" />: {}
            <FormattedCurrency amount={Math.abs(price)} currency={currency} />
          </Paragraph>
        </>
      ) : (
        <Paragraph>
          <FormattedMessage id="paymentsTab.cost" />: {}
          {getTicketPrice()}
        </Paragraph>
      )}
      <Paragraph>
        <FormattedMessage id="paymentsTab.totalCost" />: {}
        {getTicketTotalPrice()}
      </Paragraph>
      {hasDiscount &&
        discounts?.map(({ voucherId }) => (
          <Paragraph key={voucherId}>
            <FormattedMessage id="paymentsTab.discountCode" />:
            {vouchers.find(({ id }) => id === voucherId)?.code ? (
              <Link to={`/discountCodes/${vouchers.find(({ id }) => id === voucherId)?.code}`} target="_blank">{`${
                vouchers.find(({ id }) => id === voucherId)?.code
              }`}</Link>
            ) : (
              '-'
            )}
          </Paragraph>
        ))}
      {costPrice && (
        <Paragraph>
          <FormattedMessage id="paymentsTab.tcnValue" />: {}
          <FormattedCurrency amount={costPrice.amount} currency={costPrice.currency} />
        </Paragraph>
      )}
    </SummaryBlock>
  );
};

Ticket.propTypes = {
  ticket: PropTypes.shape({
    confirmedTimestamp: PropTypes.string,
    name: PropTypes.string,
    code: PropTypes.string,
    quantity: PropTypes.number,
    loyaltyPoints: PropTypes.number,
    price: PropTypes.number,
    currency: PropTypes.string,
    total: PropTypes.number,
    originalPrice: PropTypes.number,
    discounts: PropTypes.arrayOf(
      PropTypes.shape({
        voucherId: PropTypes.string
      })
    )
  }),
  vouchers: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      code: PropTypes.string
    })
  ),
  isLoyalty: PropTypes.bool,
  costPrice: PropTypes.shape({
    amount: PropTypes.number,
    currency: PropTypes.string
  })
};

export default Ticket;
